/**
 * Bounding-box geometry shared by every viewer that draws an overlay on a
 * document — the OCR image viewer (`ocr-viewer`) and the PDF viewer's tamper
 * highlight layer (`shared/ui/pdf-viewer`).
 *
 * Lives in `shared/` rather than `features/claim/` because `shared/ui` consumes
 * it: `shared → features` is a forbidden dependency direction.
 */

export function normalizedPolyToBBox(
  normalizedVertices,
  imageWidth,
  imageHeight
) {
  const xs = normalizedVertices.map((p) => p.x * imageWidth);
  const ys = normalizedVertices.map((p) => p.y * imageHeight);

  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
}

export function imageBBoxToViewerBBox(img, bboxImage) {
  const rect = img.getBoundingClientRect();

  const scaleX = rect.width / img.naturalWidth;
  const scaleY = rect.height / img.naturalHeight;

  return {
    left: bboxImage.x * scaleX,
    top: bboxImage.y * scaleY,
    width: bboxImage.width * scaleX,
    height: bboxImage.height * scaleY,
  };
}
